import React from 'react';
import {I18nextProvider} from 'react-i18next';
import PropTypes from 'prop-types';
import {i18n} from '@/settings';
import {InternationalizationProvider} from '@/contexts/InternationalizationContext';
import {InternationalizationConfigProvider} from '@/contexts/InternationalizationConfigProvider';

const InternationalizationInitProvider = ({children}) => {
  return (
    <InternationalizationProvider>
      <I18nextProvider i18n={i18n}>
        <InternationalizationConfigProvider>
          {children}
        </InternationalizationConfigProvider>
      </I18nextProvider>
    </InternationalizationProvider>
  );
};

InternationalizationInitProvider.propTypes = {
  children: PropTypes.any
};

export default InternationalizationInitProvider;
